import TermSearchModule from '~/lib/vue/modules/termsearch';

export default (services, namespace='search') => {
  return TermSearchModule.create({
    services,
    url: '/search/properties',
    placeholder: 'Find properties',
  });
};
